export default __webpack_public_path__ + "static/media/gallery-4.f505b63b.jpg";